import { render, staticRenderFns } from "./axess_setup.vue?vue&type=template&id=3f6e2f0c&"
import script from "./axess_setup.vue?vue&type=script&lang=js&"
export * from "./axess_setup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports